"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.interestNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
/**
 * normalizador del modulo MODULO_VENTA_CRUZADA
 * @param {object} fields
 * @returns
 */
const interestNormalizer = (data) => {
    var _a, _b, _c, _d, _e, _f;
    try {
        let res = null;
        const title = ((_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.title) || ((_c = (_b = data === null || data === void 0 ? void 0 : data[0]) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.title);
        const listadoCards = ((_d = data === null || data === void 0 ? void 0 : data.fields) === null || _d === void 0 ? void 0 : _d.CARACTERISTICAS_TITLO_DESCRIPTION_HREF) || ((_f = (_e = data === null || data === void 0 ? void 0 : data[0]) === null || _e === void 0 ? void 0 : _e.fields) === null || _f === void 0 ? void 0 : _f.CARACTERISTICAS_TITLO_DESCRIPTION_HREF);
        if (listadoCards && Array.isArray(listadoCards) && listadoCards.length > 0) {
            const normalizedInfo = {};
            if (title) {
                normalizedInfo["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: title });
            }
            listadoCards.map((carac, index) => {
                const { fields } = carac;
                const { title, description, titleHref, href, target } = fields;
                const card = {};
                const moreInfo = { label: titleHref ? titleHref : title };
                if (moreInfo) {
                    let buttonMoreInfo = Object.assign(Object.assign({}, moreInfo), { href: href || '' });
                    card["Button-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Button-3"]), buttonMoreInfo);
                    card["CustomLink-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["CustomLink-1"]), { href: href, title: title || '' });
                    if (!!target) {
                        card["CustomLink-1"].target = target;
                        card["Button-3"].target = target;
                    }
                }
                if (title) {
                    card["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-1"]), { text: title });
                }
                if (description) {
                    card["Text-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-2"]), { text: description });
                }
                const hasItems = Object.keys(card).length > 0;
                if (hasItems) {
                    normalizedInfo[`Charac-${index}`] = card;
                }
            });
            res = normalizedInfo;
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.interestNormalizer = interestNormalizer;
exports.default = exports.interestNormalizer;
//# sourceMappingURL=index.js.map